module.exports = __webpack_public_path__ + "img/Madeira.99ade3d9.svg";